import script from "./DayInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./DayInfo.vue?vue&type=script&setup=true&lang=ts"

import "./DayInfo.vue?vue&type=style&index=0&id=03b0e52e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03b0e52e"]])

export default __exports__